module.exports = __webpack_public_path__ + "img/wx_temp_img.791eb82e.jpg";